import { Action } from 'redux';

import { TThunkAction } from '../../types/redux';
import { EMetaStatus } from '../../types/filters';
import { FILTERS_GET_META_TYPE } from '../../constants/action_types';
import { getMeta as getMetaApi } from '../../api/getMeta';

export type TGetMetaType = 'filters/get_meta/status_changed';

export interface IGetMetaFailed extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Failed;
  error: string;
}

export interface IGetMetaSucceed extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Succeed;
  url: string;
  mapUrl: string;
  count: number;
}

export interface IGetMeta extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Loading;
}

export type TGetMeta = IGetMeta | IGetMetaFailed | IGetMetaSucceed;

let lastRequestId: Symbol;
// tslint:disable-next-line: no-any
export function getMeta(): TThunkAction<Promise<any>> {
  return (dispatch, getState, context) => {
    const requestId = lastRequestId = Symbol();

    dispatch<TGetMeta>({
      type: FILTERS_GET_META_TYPE,
      status: EMetaStatus.Loading,
    });

    const { filters: { jsonQuery } } = getState();

    return getMetaApi(context.makeRequest, { jsonQuery })
      .then((response) => {
        if (requestId !== lastRequestId) {
          return;
        }

        if (response.status === 'ok') {
          const { fullUrl, fullUrlWithoutSeo, url, mapUrl, count } = response.data;

          dispatch<TGetMeta>({
            type: FILTERS_GET_META_TYPE,
            status: EMetaStatus.Succeed,
            url: fullUrl || fullUrlWithoutSeo || url,
            mapUrl,
            count,
          });
        } else {
          dispatch<TGetMeta>({
            type: FILTERS_GET_META_TYPE,
            status: EMetaStatus.Failed,
            error: 'Произошла непредвиденная ошибка',
          });
        }
      })
      .catch((error) => {
        // context.logger.error(error);
        console.error(error);

        if (requestId !== lastRequestId) {
          return;
        }

        dispatch<TGetMeta>({
          type: FILTERS_GET_META_TYPE,
          status: EMetaStatus.Failed,
          error: 'Произошла непредвиденная ошибка',
        });
      });
  };
}
